import { PUBLIC_API_SCOPES } from '../../../../utils/publicApiScopes';

export const PUBLIC_API_SCOPE_VALUES = PUBLIC_API_SCOPES.map(scope => scope.value);

export const COMING_SOON_SCOPES = new Set(['levitate:campaigns']);

export const EXPIRATION_DAY_OPTIONS = [30, 90, 180, 365] as const;

export const DEFAULT_EXPIRATION_DAYS = 180;
